import { MenuItem, PermissionType } from 'lib-klab-core';

export function hasAdminPortalAccess(menu: readonly MenuItem[] | null | undefined): boolean {
    return (menu ?? []).some(item => {
        const code = String(item.code ?? '').trim().toUpperCase();
        const route = String(item.route ?? '').trim();
        const isNavigation = item.permission_type === PermissionType.MenuParent || item.permission_type === PermissionType.MenuItem;
        const hasAdminView = isNavigation && !!code && !code.startsWith('APP-') && /^\/admin(?:\/|[?#]|$)/.test(route);
        return hasAdminView || hasAdminPortalAccess(item.children);
    });
}
